import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, matchPath, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';

import {
  Grid,
  MenuItem,
  Link as MuiLink,
  Paper,
  Select,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';

import { RouterPaths } from '../../router/paths';
import { useGetProfileQuery } from '../../api';
import { useGetProvidersQuery } from '../../api/controllers/providers';

export const Providers: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { profileUid } = useParams<'profileUid'>();

  const [provider, setProvider] = useState('kraken');

  // api
  const { data: profile } = useGetProfileQuery(profileUid ? { profileUid } : skipToken);
  const { data: poviders } = useGetProvidersQuery({});

  // variables
  const hasSumsubData = Boolean(profile?.profile.sumsub_applicant_id);

  // active tab logic
  const tabsPaths = [RouterPaths.ProvidersWallets, RouterPaths.Ledgers];
  const activeTab = tabsPaths.filter((path) => matchPath(path, pathname))[0];

  useEffect(() => {
    if (provider) {
      const activeTabByFilter = tabsPaths.filter((path) => matchPath(path, pathname))[0];
      if (!activeTabByFilter) {
        navigate(`${RouterPaths.Providers}/${provider}/wallets`);
        return;
      }

      const providerTab = activeTabByFilter.split('/').pop();
      navigate(`${RouterPaths.Providers}/${provider}/${providerTab}`);
    }
  }, [provider]);

  return (
    <>
      <Grid size={{ xs: 12 }} sx={{ '&.MuiGrid-item': { pt: 1.6 } }}>
        <Paper
          sx={{ p: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
        >
          <Tabs value={activeTab} variant="scrollable" scrollButtons="auto">
            <Tab
              label={t('providers.tabs.wallets')}
              component={Link}
              to={`${RouterPaths.Providers}/${provider}/wallets`}
              value={RouterPaths.ProvidersWallets}
              sx={{ textTransform: 'none' }}
            />
            <Tab
              label={t('providers.tabs.ledgers')}
              component={Link}
              to={`${RouterPaths.Providers}/${provider}/ledgers`}
              value={RouterPaths.Ledgers}
              sx={{ textTransform: 'none' }}
            />
          </Tabs>

          <Select
            name={'provider'}
            value={provider}
            onChange={(e) => setProvider(e.target.value)}
            variant="standard"
            sx={{ maxWidth: '298px' }}
            fullWidth
          >
            {poviders?.providers.map((p) => (
              <MenuItem key={p.toLowerCase()} value={p.toLowerCase()}>
                {p}
              </MenuItem>
            ))}
          </Select>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Outlet />
        </Paper>
      </Grid>
    </>
  );
};
